import { userKey } from '@constants/user';
import { getCurrentTime } from '@helpers/date';

/**
 * Sets user in local storage.
 * @param {string} id - Unique identifier
 * @param {string} token - JWT token
 * @param {string} refresh - Refresh token
 * @returns {void}
 */
export const setUser = ({ token, id, refresh }) => {
  const userCredentials = {
    tokenAdded: getCurrentTime(),
    token,
    userId: id,
    refresh,
  };
  localStorage.setItem(userKey, btoa(JSON.stringify(userCredentials)));
};

/**
 * @typedef {Object} User
 * @property {string} refresh - Refresh token
 * @property {string} token - JWT token
 * @property {string} id - Unique identifier
 */

/**
 * Returns stored user or null if there is no user set in local storage.
 * @returns {null|User}
 */
export const getUser = () => {
  const user = localStorage.getItem(userKey);
  if (user) {
    const decoded = JSON.parse(atob(user));
    return decoded;
  }

  return null;
};

/**
 * Returns JWT token or null if there is no user set in local storage.
 * @returns {null|string}
 */
export const getToken = () => {
  const user = getUser();

  if (user) {
    return user.token;
  }

  return null;
};

/**
 * Returns refresh token or null if there is no user set in local storage.
 * @returns {null|string}
 */
export const getRefreshToken = () => {
  const user = getUser();

  if (user) {
    return user.refresh;
  }

  return null;
};

/**
 * Checks if user is authenticated.
 * @returns {boolean}
 */
export const isLoggedIn = () => {
  const user = getUser();

  if (user) return true;

  return false;
};

/**
 * Destroys user stored in local storage.
 * @returns {void}
 */
export const destroyToken = () => {
  localStorage.removeItem(userKey);
};
